module.exports = __webpack_public_path__ + "img/notice_empty.021f67d2.png";